import HttpRepository from './httpRepository'

export default class SerialRepository extends HttpRepository {
  async fetch(code) {
    const data = await this.get('/v1/serial', {
      params: {
        code
      }
    })
    return data
  }

  async entry(code, eventId) {
    const params = new URLSearchParams()
    params.append('code', code)
    params.append('event_id', eventId)
    const data = await this.post('/v1/serial', params)
    return data
  }

  async fetchList() {
    const data = await this.get('/v1/serial/confirm')
    return data
  }

  cancel(id) {
    return this.delete(`/v1/serial/${id}`)
  }
}
